import { connect } from 'react-redux';

import Header from './Header';

interface OwnProps {
  title: string;
  hasError?: boolean;
}

const mapStateToProps = () => ({});

const actions = {};

export default connect<object, object, OwnProps>(mapStateToProps, actions)(Header);
